import { Button, Col, Row, Stack } from "react-bootstrap"
//import { ReactComponent as ReloadIcon } from "../svgs/refresh.svg"
import Label from "./Label"
import React from "react"

type StackAction = {
    icon     :string
    onClick: () => void
}

type CStackProps = {
    header?    :string
    children?  :any
    padding?   :string
    actions?   : StackAction[]
    onReload?    : () => void
}

const CStack:React.FC<CStackProps> = ({   
        header, 
        children = [<></>], 
        padding="15px 0",
        actions=[],
        onReload = null,
    }) => {
    return <div style={{padding:padding}}>
        {/* {false && header !== "" && <Stack direction="horizontal">
            <Label padding="10px 0" fontWeight="600" color="black">{header}</Label>
            {actions.length > 0 && actions.map( (item:StackAction) => <></>)}
            <Button
                onClick={onReload!}
                variant=""
                style={{
                    backgroundColor:"transparent",
                    padding: "3px 3px",
                    color:"#565656", 
                    fontSize:"large", 
                    fontWeight:"500"}
                }>
                <ReloadIcon /> 
            </Button>
        </Stack>} */}
        <Row>
            {header !== "" && <Col>
                <Label padding="10px 0" fontWeight="600" color="black">{header}</Label>
            </Col>}
            { onReload !== null && <Col xs={4} lg={4} ><div style={{position:"absolute",right:"30px"}}>
                <Button
                    onClick={onReload!}
                    variant=""
                    style={{
                        backgroundColor:"transparent",
                        margin: "5px 0px",
                        color:"#565656"}
                    }>
                    {/* <ReloadIcon />  */}
                </Button>    
            </div></Col>}
        </Row>
        <Stack gap={1}>
        {children.length !== undefined && children.length >= 1 && [...children]}
        {children.length === undefined && children}
        </Stack>
    </div>
}

export default CStack